import { Link, useRouteError, isRouteErrorResponse } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { getErrorCode } from '@/lib/errors'

export function RouteErrorPage() {
  const error = useRouteError()

  const is404 =
    isRouteErrorResponse(error) && error.status === 404
  const errorCode = is404 ? 'route/not-found' : getErrorCode(error, 'route/unexpected')

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      {is404 ? (
        <>
          <h1 className="text-6xl font-bold text-muted-foreground">404</h1>
          <p className="text-xl">We couldn&apos;t find that page.</p>
        </>
      ) : (
        <>
          <h1 className="text-2xl font-bold">Something went wrong</h1>
          <p className="text-muted-foreground">
            We couldn&apos;t load this page. Please try again.
          </p>
        </>
      )}
      <p className="text-xs text-muted-foreground">Error code: {errorCode}</p>
      <Link to="/">
        <Button>Go Home</Button>
      </Link>
    </div>
  )
}
